/**
 * @overview Utility to test if the current display is retina
 * @module isRetina.js
 */

const query = `(-webkit-min-device-pixel-ratio: 1.5), (min-device-pixel-ratio: 1.5), (min-resolution: 1.5dppx)`;

export const isRetina = () => {
  if (window.matchMedia && window.matchMedia(query).matches) {
    return true;
  }
  
  return false;
};
